module.exports = __webpack_public_path__ + "static/seta1-d7fba18edaa82076005438f80e5fd88d.png";